
export const EmailIcon = ({
  children,
  className,
  ...props
}: React.SVGProps<SVGSVGElement>): React.JSX.Element => {
  return (
    <svg className={className}
      {...props}
    >
      {children}
      <use href="#email" />
    </svg>
  );
};
